import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由配置：定义后台页面路由表，组件均使用 import() 懒加载（按需打包）
// 路由元信息 meta.title 用于浏览器标签标题；meta.requireAuth 控制是否需要登录（false 表示白名单，如 /login）

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', requireAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: '首页仪表盘' }
  },
  // 虚拟商品管理
  {
    path: '/goods/list',
    name: 'GoodsList',
    component: () => import('@/views/goods/GoodsList.vue'),
    meta: { title: '虚拟商品列表' }
  },
  {
    path: '/goods/category',
    name: 'GoodsCategory',
    component: () => import('@/views/goods/GoodsCategory.vue'),
    meta: { title: '虚拟商品分类' }
  },
  // 库存管理（暂时隐藏 2026-08-11）
  // {
  //   path: '/goods/stock',
  //   name: 'GoodsStock',
  //   component: () => import('@/views/goods/GoodsStock.vue'),
  //   meta: { title: '库存管理' }
  // },
  {
    path: '/goods/audit',
    name: 'GoodsAudit',
    component: () => import('@/views/goods/GoodsAudit.vue'),
    meta: { title: '商品审核' }
  },
  // 订单管理
  {
    path: '/order/list',
    name: 'OrderList',
    component: () => import('@/views/order/OrderList.vue'),
    meta: { title: '兑换订单' }
  },
  {
    path: '/order/stats',
    name: 'OrderStats',
    component: () => import('@/views/order/OrderStats.vue'),
    meta: { title: '订单统计' }
  },
  {
    path: '/order/refund',
    name: 'OrderRefund',
    component: () => import('@/views/order/OrderRefund.vue'),
    meta: { title: '退款管理' }
  },
  {
    path: '/order/original',
    name: 'OrderOriginal',
    component: () => import('@/views/order/OrderOriginal.vue'),
    meta: { title: '原始订单' }
  },
  {
    path: '/order/points-record',
    name: 'OrderPointsRecord',
    component: () => import('@/views/order/OrderPointsRecord.vue'),
    meta: { title: '积分产生记录' }
  },
  // 活动管理
  {
    path: '/activity/achievement',
    name: 'ActivityAchievement',
    component: () => import('@/views/activity/Achievement.vue'),
    meta: { title: '达标活动' }
  },
  {
    path: '/activity/signin',
    name: 'ActivitySignin',
    component: () => import('@/views/activity/Signin.vue'),
    meta: { title: '签到活动' }
  },
  {
    path: '/activity/banner',
    name: 'BannerConfig',
    component: () => import('@/views/activity/BannerConfig.vue'),
    meta: { title: 'Banner配置' }
  },
  // 会员管理
  {
    path: '/member/list',
    name: 'MemberList',
    component: () => import('@/views/member/MemberList.vue'),
    meta: { title: '会员列表' }
  },
  {
    path: '/member/level',
    name: 'MemberLevel',
    component: () => import('@/views/member/MemberLevel.vue'),
    meta: { title: '等级配置' }
  },
  // {
  //   path: '/member/benefit',
  //   name: 'MemberBenefit',
  //   component: () => import('@/views/member/MemberBenefit.vue'),
  //   meta: { title: '权益配置' }
  // },
  {
    path: '/member/benefit-record',
    name: 'MemberBenefitRecord',
    component: () => import('@/views/member/MemberBenefitRecord.vue'),
    meta: { title: '权益领取记录' }
  },
  // 券包管理
  {
    path: '/coupon/template',
    name: 'CouponTemplate',
    component: () => import('@/views/coupon/Template.vue'),
    meta: { title: '券模板' }
  },
  {
    path: '/coupon/audit',
    name: 'CouponAudit',
    component: () => import('@/views/coupon/CouponAudit.vue'),
    meta: { title: '立减金审核' }
  },
  {
    path: '/coupon/user',
    name: 'CouponUser',
    component: () => import('@/views/coupon/User.vue'),
    meta: { title: '用户券包' }
  },
  {
    path: '/coupon/verify',
    name: 'CouponVerify',
    component: () => import('@/views/coupon/Verify.vue'),
    meta: { title: '核销记录' }
  },
  // 放电收益
  {
    path: '/discharge/order',
    name: 'DischargeOrder',
    component: () => import('@/views/discharge/Order.vue'),
    meta: { title: '放电订单' }
  },
  {
    path: '/discharge/income',
    name: 'DischargeIncome',
    component: () => import('@/views/discharge/Income.vue'),
    meta: { title: '收益明细' }
  },
  {
    path: '/discharge/withdraw',
    name: 'DischargeWithdraw',
    component: () => import('@/views/discharge/Withdraw.vue'),
    meta: { title: '提现管理' }
  },
  {
    path: '/discharge/station',
    name: 'DischargeStation',
    component: () => import('@/views/discharge/Station.vue'),
    meta: { title: '站点管理' }
  },
  // 数据统计
  {
    path: '/stats/integral',
    name: 'StatsIntegral',
    component: () => import('@/views/stats/Integral.vue'),
    meta: { title: '积分统计' }
  },
  {
    path: '/stats/exchange',
    name: 'StatsExchange',
    component: () => import('@/views/stats/Exchange.vue'),
    meta: { title: '兑换统计' }
  },
  {
    path: '/stats/coupon',
    name: 'StatsCoupon',
    component: () => import('@/views/stats/Coupon.vue'),
    meta: { title: '券使用统计' }
  },
  // 兑换码管理
  {
    path: '/redeem/code',
    name: 'RedeemCode',
    component: () => import('@/views/redeemcode/RedeemCode.vue'),
    meta: { title: '兑换码兑换' }
  },
  {
    path: '/redeem/record',
    name: 'RedeemRecord',
    component: () => import('@/views/redeemcode/RedeemRecord.vue'),
    meta: { title: '兑换记录' }
  },
  // 系统管理
  {
    path: '/system/admin',
    name: 'SystemAdmin',
    component: () => import('@/views/system/Admin.vue'),
    meta: { title: '人员管理' }
  },
  {
    path: '/system/role',
    name: 'SystemRole',
    component: () => import('@/views/system/Role.vue'),
    meta: { title: '角色权限' }
  },
  {
    path: '/system/log',
    name: 'SystemLog',
    component: () => import('@/views/system/Log.vue'),
    meta: { title: '操作日志' }
  },
  {
    path: '/system/config',
    name: 'SystemConfig',
    component: () => import('@/views/system/Config.vue'),
    meta: { title: '系统配置' }
  },
  {
    path: '/system/menu',
    name: 'SystemMenu',
    component: () => import('@/views/system/Menu.vue'),
    meta: { title: '系统菜单设置' }
  },
  {
    path: '/system/pointRule',
    name: 'SystemPointRule',
    component: () => import('@/views/system/PointRule.vue'),
    meta: { title: '积分规则配置' }
  },
  {
    path: '/system/notice',
    name: 'SystemNotice',
    component: () => import('@/views/system/Notice.vue'),
    meta: { title: '系统公告' }
  }
]

// 注：当前路由表未配置 404 通配路由（path: '*' 兜底页面），访问未定义路径不会重定向到统一的 404 页面
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫：设置文档标题，并做登录鉴权
// 鉴权逻辑：当目标路由 meta.requireAuth !== false（即需要登录）且 localStorage 无 admin_user 时，重定向到 /login
// 白名单：/login 路由 meta.requireAuth=false，无需登录即可访问
// 兜底：未匹配路由则由 VueRouter 默认行为处理（当前路由表无 '*' 404 兜底，见下方说明）
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 常畅充权益系统` : '常畅充权益系统'
  
  // 检查是否需要登录
  if (to.meta.requireAuth !== false) {
    const user = localStorage.getItem('admin_user')
    if (!user && to.path !== '/login') {
      next('/login')
      return
    }
  }
  
  next()
})

export default router
